import { render, staticRenderFns } from "./virus.vue?vue&type=template&id=9a3b2b6e"
import script from "./virus.vue?vue&type=script&lang=js"
export * from "./virus.vue?vue&type=script&lang=js"
import style0 from "./virus.vue?vue&type=style&index=0&id=9a3b2b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports